export default class mobileMenu {

    static init() {

        $('.full-slide').slick({
            centerMode: true,
            centerPadding: '60px',
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<svg class="icon-slide-left"><use xlink:href="#icon-slide-left"></use></svg>',
            nextArrow: '<svg class="icon-slide-right"><use xlink:href="#icon-slide-right"></use></svg>',
            responsive: [{
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        arrows: false
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });

    }

}